import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { classNames } from '../../../utils/classNames';
import { useSignInWithAgentMutation } from '../../../store/auth/authApi';
import { useNavigate } from 'react-router-dom';
import TypingMessage from '../../../components/typing-message/TypingMessage';
import { useSignUpWithAgentMutation } from '../../../store/user/userApi';

const ChatContent = ({
    type = 'sign-up'
}: {
    type?: 'sign-up' | 'sign-in'
}) => {
    const navigate = useNavigate();

    const [signInAgent] = useSignInWithAgentMutation()
    const [signUpAgent] = useSignUpWithAgentMutation()
    const { authMessages, error } = useSelector(
        (state: RootState) => state.chats
    );

    const getAuthSignInMessages = (usedBefore?: boolean) => {
        if (type === 'sign-up') {
            signUpAgent({ chatData: [], dashboard: 'Claire' }).unwrap();
        } else {
            signInAgent({ chatData: [], dashboard: 'Claire' }).unwrap();
        }
    }

    const chatEndRef = useRef<HTMLDivElement>(null);
    const scrollToBottom = () => setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100)

    useEffect(() => {
        getAuthSignInMessages()
    }, []);

    useEffect(() => {
        if (authMessages?.find(message => message?.agent?.stage === 'authenticated') || localStorage.getItem('accessToken')) {
            setTimeout(() => {
                navigate('/dashboard')
            }, 500)
        }
        scrollToBottom();
    }, [authMessages]);

    return (
        <div className='h-[70vh] md:h-[60vh] w-full overflow-auto bg-gray-100 p-5 flex flex-col'>
            {authMessages?.map(
                (conversation, index: number) => (
                    <div key={conversation?.agent?.message || conversation?.user?.message + conversation?._id + index} className='my-2 flex'>
                        {conversation?.agent ?
                            <div className='w-full flex flex-row'>
                                <img alt='avatar' width={34} height={34} className='rounded-full w-9 h-9 object-cover border border-black mr-4' src='/assets/agents/claire-agent-icon.svg' />
                                <div className='bg-white max-w-[90%] rounded-2xl p-4'>
                                    {conversation?.agent?.message && <TypingMessage scrollToBottom={scrollToBottom} message={conversation?.agent?.message} typingSpeed={500} updatedAt={new Date().toISOString()} />}
                                </div>
                            </div>
                            :
                            <div className={classNames('bg-primary-default max-w-[90%] text-white rounded-2xl p-4 ml-auto break-words',
                                conversation?.user?.type === 'pending' ? 'opacity-50' : '',
                                conversation?.user?.type === 'error' ? 'border-2 border-red-500 opacity-60' : ''
                            )}
                            >
                                {conversation?.user?.message}
                            </div>
                        }
                    </div>
                )
            )}
            <p className='text-red-400'>{error}</p>
            <div ref={chatEndRef} />
        </div>
    )
}

export default ChatContent;